import { Facade, vinject, vsingleton, VueModule } from '@niknevis/vue-modules'
import { UserStore } from '@/modules/user/stores/user.store'


type HandlerOrData = (() => any) | any

const returnHandlerOrData = (handlerOrData: HandlerOrData) => {
  if (typeof handlerOrData === 'function') {
    return handlerOrData()
  } else {
    return handlerOrData
  }
}

@vsingleton()
export default class UserService {
  public readonly userType: string

  constructor(
    @vinject('rootModule') public rootModule: VueModule,
    private readonly store: UserStore
  ) {
    this.userType = this.rootModule.exports.userType
  }

  get isLoading() {
    return this.store.isLoading
  }

  get user() {
    return this.store.user
  }

  get permissions() {
    return this.store.permissions
  }

  can(perm: string) {
    return this
      .store
      .permissions
      .includes(perm)
  }

  canAny(perms: string[]) {
    return perms.some(
      perm => this.can(perm)
    )
  }

  ifCan(perm: string, handlerOrData: HandlerOrData) {
    if (!!!perm) {
      return returnHandlerOrData(handlerOrData)
    }
    if (this.can(perm)) {
      return returnHandlerOrData(handlerOrData)
    } else {
      return null
    }
  }

  ifCanAny(perms: string[], handlerOrData: HandlerOrData) {
    if (!!!perms) {
      return returnHandlerOrData(handlerOrData)
    }
    if (this.canAny(perms)) {
      return returnHandlerOrData(handlerOrData)
    } else {
      return null
    }
  }

  logOut() {
    this.store.logOut()
  }

  init() {
    this.store.getFrontData()
  }
}

export class User extends Facade<UserService>() {
  static getFacadeAccessor() {
    return UserService
  }
}
